import { createContext, useContext, useState, useEffect } from "react";
import { getCurrentStudent, logoutStudent as logoutStudentApi } from "../api/student/studentAuthApi";

const StudentAuthContext = createContext();

export const StudentAuthProvider = ({ children }) => {
  const [student, setStudent] = useState(null);
  const [loading, setLoading] = useState(true);

  const fetchStudent = async () => {
    try {
      const data = await getCurrentStudent();
      const studentData = data?.student || data;
      setStudent(studentData);
      return studentData;
    } catch (error) {
      setStudent(null);
      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStudent();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = async () => {
    try {
      await logoutStudentApi();
    } catch (error) {
      // ignore — clear local state regardless
    } finally {
      setStudent(null);
    }
  };

  const refreshStudent = async () => {
    return fetchStudent();
  };

  const value = {
    student,
    loading,
    isAuthenticated: !!student,
    logout,
    refreshStudent,
  };

  return (
    <StudentAuthContext.Provider value={value}>
      {children}
    </StudentAuthContext.Provider>
  );
};

export const useStudentAuth = () => {
  const context = useContext(StudentAuthContext);
  if (!context) {
    throw new Error("useStudentAuth must be used within a StudentAuthProvider");
  }
  return context;
};

export default StudentAuthContext;
